import * as React from "react";
import { AccreditationStatus } from "@coinlist/frontend-ui-lib"
require("@coinlist/frontend-ui-lib/dist/style.css");

export default function AccreditationStatusCmp(props) {
    return (
        <AccreditationStatus locale={props.locale} status={props.status}/>
    );
}
